import { Component, OnInit } from '@angular/core';
import { creFadeInOut } from 'cre-ng';

import { User } from '@app/core/core.model';
import { DriverTeamInformation } from '@app/core/driver-wig.model';
import { IDriverWigService } from '@app/core/services/interface/IDriverWigService';
import { ServiceFactory } from '@app/core/services/service.factory';
import { AuthService } from '@app/core/auth.service';
import { LogoService } from '@app/core/logo.service';

@Component({
  animations: [creFadeInOut],
  selector: 'driver-team-information',
  styleUrls: ['./driver-team-information.component.css'],
  templateUrl: './driver-team-information.component.html',
})
export class DriverTeamInformationComponent implements OnInit {
  driverWigService: IDriverWigService;
  driverInformation: DriverTeamInformation;
  isLoading: boolean;
  fleetLogoUrl: string;
  leagueLogoUrl: string;
  errorToShow: string;
  monthToShow: string;
  dateToShow: number;

  private currentUser: User;
  private monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  constructor(
    private logoService: LogoService,
    private authService: AuthService,
    private serviceFactory: ServiceFactory
  ) {
    this.driverWigService = serviceFactory.getDriverWigService();
  }

  ngOnInit() {
    this.errorToShow = null;
    this.currentUser = this.authService.getCurrentUser();
    this.isLoading = true;
    void this.driverWigService
      .getDriverTeamInformation(this.currentUser.username)
      .then((data) => {
        this.driverInformation = data;
        const parseDate = new Date(this.driverInformation.weekEnding);
        this.dateToShow = parseDate.getDate();
        this.monthToShow = this.monthNames[parseDate.getMonth()];
        if (!!this.driverInformation.fleetLogo && this.driverInformation.fleetLogo != null) {
          this.fleetLogoUrl = this.logoService.getImageUrl(
            encodeURIComponent(this.driverInformation.fleetLogo)
          );
        }
        if (!!this.driverInformation.leagueLogo && this.driverInformation.leagueLogo != null) {
          this.leagueLogoUrl = this.logoService.getImageUrl(
            encodeURIComponent(this.driverInformation.leagueLogo)
          );
        }
        this.isLoading = false;
      })
      .catch((error) => {
        if (
          !!error.error &&
          error.error.includes('get a valid fleet team id for that driver in the weekstart')
        ) {
          this.errorToShow =
            'You were not assigned to a fleet that was part of a team for the latest WIG week. ' +
            'If you currently belong to a fleet that is part of a team, you will see stats here when they are updated for the next week.';
        }
        this.isLoading = false;
      });
  }
}
